import { render } from "./MuteChatDialog.vue?vue&type=template&id=1ff294c4&scoped=true"
import script from "./MuteChatDialog.vue?vue&type=script&lang=js"
export * from "./MuteChatDialog.vue?vue&type=script&lang=js"

import "./MuteChatDialog.vue?vue&type=style&index=0&id=1ff294c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff294c4"]])

export default __exports__